import { View } from 'foundations-components/components/View';
import PaymentMethodOnFileV2 from '../PaymentMethodOnFileV2';
import MaybeCancellationAndRefundPolicies from './MaybeCancellationAndRefundPolicies';
import TermsOfService from './TermsOfService';
import { useMerchantTermsOfServiceMessage } from '../../hooks/useMerchantTermsOfServiceMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TermsOfServiceInputs = ({
  policySettings,
  collectPaymentMethodOnFile,
  isZeroCheckout
}) => {
  const translationMessageKey = useMerchantTermsOfServiceMessage();
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "terms-of-service-inputs",
    paddingBlockStart: "300",
    children: [collectPaymentMethodOnFile && /*#__PURE__*/_jsx(PaymentMethodOnFileV2, {}), policySettings.acknowledgementRequired && /*#__PURE__*/_jsx(TermsOfService, {
      translationMessageKey: translationMessageKey,
      isZeroCheckout: isZeroCheckout
    }), policySettings.acknowledgementRequired && /*#__PURE__*/_jsx(MaybeCancellationAndRefundPolicies, {
      policySettings: policySettings
    })]
  });
};
export default TermsOfServiceInputs;